// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================================
   PAGE
====================================================== */

.pokemon-page {
  min-height: calc(100vh - 80px);
  padding: 40px 20px 60px;
  color: #f8fafc;
  background: linear-gradient(135deg, #0f172a, #111827, #0f172a);

}

.pokemon-container {
  width: 100%;
  max-width: 1400px;
  margin: auto;
}

/* ======================================================
   HEADER
====================================================== */

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
  margin-bottom: 30px;
  margin-top: 50px;
    border-radius: 20px;


}

.subtitle {
  color: #f59e0b;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.page-header h1 {
  margin: 8px 0;
  font-size: 2.5rem;
}

.page-header p {
  max-width: 650px;
  color: #94a3b8;
  line-height: 1.6;
}

.statistics {
  display: flex;
  gap: 12px;
}

.statistics div {
  min-width: 120px;
  padding: 14px 20px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 10px;
}

.statistics small {
  display: block;
  color: #64748b;
  font-size: 12px;
}

.statistics strong {
  display: block;
  margin-top: 5px;
  color: #f59e0b;
  font-size: 1.4rem;
}

/* ======================================================
   RECHERCHE
====================================================== */

.search-box {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding: 20px;
  margin-bottom: 20px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 14px;
}

.search-box input,
.search-box select {
  padding: 13px 15px;
  color: white;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 9px;
  outline: none;
  font-size: 14px;
}

.search-box input {
  flex: 1 1;
  min-width: 300px;
}

.search-box select {
  width: 220px;
}

.search-box button,
.view-buttons button {
  padding: 12px 18px;
  color: white;
  background: #334155;
  border: 1px solid #475569;
  border-radius: 9px;
  cursor: pointer;
}

/* ======================================================
   MODES
====================================================== */

.view-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.view-buttons button {
  color: #cbd5e1;
}

.view-buttons button.active {
  color: #0f172a;
  background: #f59e0b;
  border-color: #f59e0b;
  font-weight: 800;
}

/* ======================================================
   PAGINATION
====================================================== */

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin: 18px 0;
  color: #64748b;
  font-size: 15px;
}

.pagination strong {
  color: #cbd5e1;
}

.pagination > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pagination button {
  padding: 8px 14px;
  color: #0f172a;
  background: #f59e0b;
  border: 0;
  border-radius: 8px;
  font-weight: 800;
  cursor: pointer;
}

.pagination button:disabled {
  color: #64748b;
  background: #1e293b;
  cursor: not-allowed;
}

/* ======================================================
   LISTE POKEMON
====================================================== */

.pokemon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 18px;
}

.pokemon-card {
  padding: 15px;
  text-align: center;
  background: linear-gradient(180deg, #1e293b, #172033);
  border: 1px solid #334155;
  border-radius: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.pokemon-card:hover {
  transform: translateY(-5px);
  border-color: #f59e0b;
  box-shadow: 0 12px 25px rgba(245, 158, 11, 0.15);
}

.pokemon-card img {
  width: 125px;
  height: 125px;
  object-fit: contain;
}

.pokemon-number {
  text-align: right;
  color: #64748b;
  font-size: 13px;
}

.pokemon-card h3 {
  margin: 5px 0 10px;
  font-size: 1.2rem;
}

/* ======================================================
   TYPES
====================================================== */

.types {
  display: flex;
  justify-content: center;
  gap: 5px;
  flex-wrap: wrap;
}

.types span {
  padding: 4px 8px;
  color: white;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 800;
}

/* ======================================================
   EVOLUTION : 2 COLONNES
====================================================== */

.evolution-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.evolution-group {
  min-width: 0;
  padding: 18px;
  background: linear-gradient(180deg, #1e293b, #172033);
  border: 1px solid #334155;
  border-radius: 15px;
  overflow: hidden;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #334155;
}

.group-header span {
  color: #f59e0b;
  font-size: 10px;
  font-weight: 800;
}

.group-header h2 {
  margin: 5px 0 0;
  font-size: 1.15rem;
}

.group-count {
  color: #64748b;
  font-size: 10px;
}

/* ======================================================
   ARBRE D'EVOLUTION
====================================================== */

.evolution-content {
  overflow-x: auto;
  padding-bottom: 5px;
}

.evolution-tree {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: max-content;
}

.evolution-branches {
  display: flex;
  align-items: center;
  gap: 10px;
}

.evolution-arrow {
  color: #f59e0b;
  font-size: 1.5rem;
  font-weight: 900;
}

.evolution-small-card {
  width: 115px;
  min-width: 115px;
  padding: 10px;
  text-align: center;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 10px;
}

.evolution-small-card small {
  color: #f59e0b;
  font-size: 12px;
  font-weight: 800;
}

.evolution-small-card img {
  width: 75px;
  height: 75px;
  object-fit: contain;
  display: block;
  margin: 3px auto;
}

.evolution-small-card strong {
  display: block;
  color: #e2e8f0;
  font-size: 11px;
  margin-bottom: 6px;
}

/* ======================================================
   CHARGEMENT
====================================================== */

.loading {
  padding: 80px 20px;
  text-align: center;
}

.loading div {
  font-size: 3rem;
}

.loading h2 {
  color: #f59e0b;
}

.loading p {
  color: #64748b;
}

/* ======================================================
   AUCUN RESULTAT
====================================================== */

.empty {
  padding: 80px 20px;
  text-align: center;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 14px;
}

.empty div {
  font-size: 3rem;
}

.empty p {
  color: #64748b;
}

/* ======================================================
   MODAL
====================================================== */

.modal-background {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: rgba(2, 6, 23, 0.88);
  backdrop-filter: blur(7px);
}

.modal {
  position: relative;
  width: 100%;
  max-width: 1050px;
  max-height: 92vh;
  overflow-y: auto;
  padding: 30px;
  background: linear-gradient(145deg, #1e293b, #111827);
  border: 1px solid #475569;
  border-radius: 20px;
}

.close-button {
  position: sticky;
  float: right;
  top: 0;
  z-index: 10;
  width: 36px;
  height: 36px;
  color: white;
  background: #334155;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
}

/* ======================================================
   HERO MODAL
====================================================== */

.modal-hero {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 30px;
  align-items: center;
  margin-bottom: 30px;
}

.hero-image {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 260px;
  background: radial-gradient(circle, #334155, #0f172a);
  border: 1px solid #475569;
  border-radius: 18px;
}

.hero-image img {
  width: 230px;
  height: 230px;
  object-fit: contain;
}

.modal-hero h2 {
  margin: 5px 0 12px;
  font-size: 2.5rem;
}

.pokemon-id {
  color: #64748b;
}

.modal-hero p {
  color: #94a3b8;
  line-height: 1.7;
}

/* ======================================================
   INFORMATIONS
====================================================== */

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.info-item {
  padding: 13px;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 9px;
}

.info-item small {
  display: block;
  margin-bottom: 5px;
  color: #64748b;
  font-size: 10px;
  text-transform: uppercase;
}

.info-item strong {
  color: #e2e8f0;
  font-size: 12px;
}

/* ======================================================
   SECTIONS MODAL
====================================================== */

.modal-section {
  padding: 20px;
  margin-bottom: 20px;
  background: #0f172a;
  border: 1px solid #334155;
  border-radius: 14px;
}

.modal-section h3 {
  margin: 0 0 18px;
  color: #f59e0b;
}
.modal-section p {
  color: #e2e8f0;
}

/* ======================================================
   STATS
====================================================== */

.stat {
  margin-bottom: 14px;
}

.stat-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  color: #cbd5e1;
  font-size: 12px;
}

.stat-bar {
  height: 8px;
  overflow: hidden;
  background: #1e293b;
  border-radius: 10px;
}

.stat-bar div {
  height: 100%;
  background: linear-gradient(90deg, #f59e0b, #38bdf8);
  border-radius: 10px;
}

/* ======================================================
   TALENTS
====================================================== */

.ability-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ability {
  padding: 10px 12px;
  color: #cbd5e1;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 8px;
}

.ability span {
  float: right;
  color: #f59e0b;
  font-size: 9px;
  font-weight: 800;
}

/* ======================================================
   CAPACITES
====================================================== */

.moves {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 160px;
  overflow-y: auto;
}

.moves span {
  padding: 6px 9px;
  color: #cbd5e1;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 7px;
  font-size: 10px;
}

/* ======================================================
   EVOLUTION MODAL
====================================================== */

.modal-evolution {
  overflow-x: auto;
}

/* ======================================================
   DRESSEUR
====================================================== */

.trainer {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  padding: 20px;
  background: linear-gradient(135deg, #0f172a, #172033);
  border: 1px solid #334155;
  border-radius: 14px;
}

.trainer > img {
  width: 90px;
  height: 90px;
  object-fit: contain;
  image-rendering: pixelated;
  border: 2px solid #38bdf8;
  border-radius: 50%;
  background: #1e293b;
}

.trainer > div:nth-child(2) {
  flex: 1 1;
}

.trainer small {
  display: block;
  margin-bottom: 5px;
  color: #64748b;
  font-size: 9px;
}

.trainer h3 {
  margin: 0 0 5px;
    color: #f59e0b;

}

.trainer strong {
  display: block;
  margin-bottom: 10px;
  color: #38bdf8;
}

.trainer p {
  margin: 0;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.5;
}

/* ======================================================
   RESPONSIVE
====================================================== */

@media (max-width: 900px) {
  .evolution-grid {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal-hero {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .pokemon-page {
    padding: 25px 10px;
  }

  .page-header h1 {
    font-size: 1.8rem;
  }

  .statistics {
    width: 100%;
  }

  .statistics div {
    flex: 1 1;
  }

  .search-box input {
    min-width: 100%;
  }

  .search-box select {
    width: 100%;
  }

  .pagination {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/pokemonpage/PokemonPage.css"],"names":[],"mappings":"AAAA;;wDAEwD;;AAExD;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,8DAA8D;;AAEhE;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;IACd,mBAAmB;;;AAGvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;wDAEwD;;AAExD;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;wDAEwD;;AAExD;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;wDAEwD;;AAExD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;wDAEwD;;AAExD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;;wDAEwD;;AAExD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;wDAEwD;;AAExD;EACE,gBAAgB;AAClB;;AAEA;;wDAEwD;;AAExD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;EACb,qDAAqD;EACrD,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;IACb,cAAc;;AAElB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wDAEwD;;AAExD;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ======================================================\r\n   PAGE\r\n====================================================== */\r\n\r\n.pokemon-page {\r\n  min-height: calc(100vh - 80px);\r\n  padding: 40px 20px 60px;\r\n  color: #f8fafc;\r\n  background: linear-gradient(135deg, #0f172a, #111827, #0f172a);\r\n\r\n}\r\n\r\n.pokemon-container {\r\n  width: 100%;\r\n  max-width: 1400px;\r\n  margin: auto;\r\n}\r\n\r\n/* ======================================================\r\n   HEADER\r\n====================================================== */\r\n\r\n.page-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 25px;\r\n  margin-bottom: 30px;\r\n  margin-top: 50px;\r\n    border-radius: 20px;\r\n\r\n\r\n}\r\n\r\n.subtitle {\r\n  color: #f59e0b;\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.page-header h1 {\r\n  margin: 8px 0;\r\n  font-size: 2.5rem;\r\n}\r\n\r\n.page-header p {\r\n  max-width: 650px;\r\n  color: #94a3b8;\r\n  line-height: 1.6;\r\n}\r\n\r\n.statistics {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.statistics div {\r\n  min-width: 120px;\r\n  padding: 14px 20px;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 10px;\r\n}\r\n\r\n.statistics small {\r\n  display: block;\r\n  color: #64748b;\r\n  font-size: 12px;\r\n}\r\n\r\n.statistics strong {\r\n  display: block;\r\n  margin-top: 5px;\r\n  color: #f59e0b;\r\n  font-size: 1.4rem;\r\n}\r\n\r\n/* ======================================================\r\n   RECHERCHE\r\n====================================================== */\r\n\r\n.search-box {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 14px;\r\n}\r\n\r\n.search-box input,\r\n.search-box select {\r\n  padding: 13px 15px;\r\n  color: white;\r\n  background: #0f172a;\r\n  border: 1px solid #475569;\r\n  border-radius: 9px;\r\n  outline: none;\r\n  font-size: 14px;\r\n}\r\n\r\n.search-box input {\r\n  flex: 1;\r\n  min-width: 300px;\r\n}\r\n\r\n.search-box select {\r\n  width: 220px;\r\n}\r\n\r\n.search-box button,\r\n.view-buttons button {\r\n  padding: 12px 18px;\r\n  color: white;\r\n  background: #334155;\r\n  border: 1px solid #475569;\r\n  border-radius: 9px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ======================================================\r\n   MODES\r\n====================================================== */\r\n\r\n.view-buttons {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.view-buttons button {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.view-buttons button.active {\r\n  color: #0f172a;\r\n  background: #f59e0b;\r\n  border-color: #f59e0b;\r\n  font-weight: 800;\r\n}\r\n\r\n/* ======================================================\r\n   PAGINATION\r\n====================================================== */\r\n\r\n.pagination {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 15px;\r\n  margin: 18px 0;\r\n  color: #64748b;\r\n  font-size: 15px;\r\n}\r\n\r\n.pagination strong {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.pagination > div {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.pagination button {\r\n  padding: 8px 14px;\r\n  color: #0f172a;\r\n  background: #f59e0b;\r\n  border: 0;\r\n  border-radius: 8px;\r\n  font-weight: 800;\r\n  cursor: pointer;\r\n}\r\n\r\n.pagination button:disabled {\r\n  color: #64748b;\r\n  background: #1e293b;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ======================================================\r\n   LISTE POKEMON\r\n====================================================== */\r\n\r\n.pokemon-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\r\n  gap: 18px;\r\n}\r\n\r\n.pokemon-card {\r\n  padding: 15px;\r\n  text-align: center;\r\n  background: linear-gradient(180deg, #1e293b, #172033);\r\n  border: 1px solid #334155;\r\n  border-radius: 14px;\r\n  cursor: pointer;\r\n  transition: 0.2s;\r\n}\r\n\r\n.pokemon-card:hover {\r\n  transform: translateY(-5px);\r\n  border-color: #f59e0b;\r\n  box-shadow: 0 12px 25px rgba(245, 158, 11, 0.15);\r\n}\r\n\r\n.pokemon-card img {\r\n  width: 125px;\r\n  height: 125px;\r\n  object-fit: contain;\r\n}\r\n\r\n.pokemon-number {\r\n  text-align: right;\r\n  color: #64748b;\r\n  font-size: 13px;\r\n}\r\n\r\n.pokemon-card h3 {\r\n  margin: 5px 0 10px;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* ======================================================\r\n   TYPES\r\n====================================================== */\r\n\r\n.types {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.types span {\r\n  padding: 4px 8px;\r\n  color: white;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n}\r\n\r\n/* ======================================================\r\n   EVOLUTION : 2 COLONNES\r\n====================================================== */\r\n\r\n.evolution-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.evolution-group {\r\n  min-width: 0;\r\n  padding: 18px;\r\n  background: linear-gradient(180deg, #1e293b, #172033);\r\n  border: 1px solid #334155;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n}\r\n\r\n.group-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding-bottom: 15px;\r\n  margin-bottom: 15px;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.group-header span {\r\n  color: #f59e0b;\r\n  font-size: 10px;\r\n  font-weight: 800;\r\n}\r\n\r\n.group-header h2 {\r\n  margin: 5px 0 0;\r\n  font-size: 1.15rem;\r\n}\r\n\r\n.group-count {\r\n  color: #64748b;\r\n  font-size: 10px;\r\n}\r\n\r\n/* ======================================================\r\n   ARBRE D'EVOLUTION\r\n====================================================== */\r\n\r\n.evolution-content {\r\n  overflow-x: auto;\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.evolution-tree {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  min-width: max-content;\r\n}\r\n\r\n.evolution-branches {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.evolution-arrow {\r\n  color: #f59e0b;\r\n  font-size: 1.5rem;\r\n  font-weight: 900;\r\n}\r\n\r\n.evolution-small-card {\r\n  width: 115px;\r\n  min-width: 115px;\r\n  padding: 10px;\r\n  text-align: center;\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 10px;\r\n}\r\n\r\n.evolution-small-card small {\r\n  color: #f59e0b;\r\n  font-size: 12px;\r\n  font-weight: 800;\r\n}\r\n\r\n.evolution-small-card img {\r\n  width: 75px;\r\n  height: 75px;\r\n  object-fit: contain;\r\n  display: block;\r\n  margin: 3px auto;\r\n}\r\n\r\n.evolution-small-card strong {\r\n  display: block;\r\n  color: #e2e8f0;\r\n  font-size: 11px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n/* ======================================================\r\n   CHARGEMENT\r\n====================================================== */\r\n\r\n.loading {\r\n  padding: 80px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.loading div {\r\n  font-size: 3rem;\r\n}\r\n\r\n.loading h2 {\r\n  color: #f59e0b;\r\n}\r\n\r\n.loading p {\r\n  color: #64748b;\r\n}\r\n\r\n/* ======================================================\r\n   AUCUN RESULTAT\r\n====================================================== */\r\n\r\n.empty {\r\n  padding: 80px 20px;\r\n  text-align: center;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 14px;\r\n}\r\n\r\n.empty div {\r\n  font-size: 3rem;\r\n}\r\n\r\n.empty p {\r\n  color: #64748b;\r\n}\r\n\r\n/* ======================================================\r\n   MODAL\r\n====================================================== */\r\n\r\n.modal-background {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 2000;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 20px;\r\n  background: rgba(2, 6, 23, 0.88);\r\n  backdrop-filter: blur(7px);\r\n}\r\n\r\n.modal {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 1050px;\r\n  max-height: 92vh;\r\n  overflow-y: auto;\r\n  padding: 30px;\r\n  background: linear-gradient(145deg, #1e293b, #111827);\r\n  border: 1px solid #475569;\r\n  border-radius: 20px;\r\n}\r\n\r\n.close-button {\r\n  position: sticky;\r\n  float: right;\r\n  top: 0;\r\n  z-index: 10;\r\n  width: 36px;\r\n  height: 36px;\r\n  color: white;\r\n  background: #334155;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ======================================================\r\n   HERO MODAL\r\n====================================================== */\r\n\r\n.modal-hero {\r\n  display: grid;\r\n  grid-template-columns: 280px 1fr;\r\n  gap: 30px;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.hero-image {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 260px;\r\n  background: radial-gradient(circle, #334155, #0f172a);\r\n  border: 1px solid #475569;\r\n  border-radius: 18px;\r\n}\r\n\r\n.hero-image img {\r\n  width: 230px;\r\n  height: 230px;\r\n  object-fit: contain;\r\n}\r\n\r\n.modal-hero h2 {\r\n  margin: 5px 0 12px;\r\n  font-size: 2.5rem;\r\n}\r\n\r\n.pokemon-id {\r\n  color: #64748b;\r\n}\r\n\r\n.modal-hero p {\r\n  color: #94a3b8;\r\n  line-height: 1.7;\r\n}\r\n\r\n/* ======================================================\r\n   INFORMATIONS\r\n====================================================== */\r\n\r\n.info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\r\n  gap: 12px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.info-item {\r\n  padding: 13px;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 9px;\r\n}\r\n\r\n.info-item small {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #64748b;\r\n  font-size: 10px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.info-item strong {\r\n  color: #e2e8f0;\r\n  font-size: 12px;\r\n}\r\n\r\n/* ======================================================\r\n   SECTIONS MODAL\r\n====================================================== */\r\n\r\n.modal-section {\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n  background: #0f172a;\r\n  border: 1px solid #334155;\r\n  border-radius: 14px;\r\n}\r\n\r\n.modal-section h3 {\r\n  margin: 0 0 18px;\r\n  color: #f59e0b;\r\n}\r\n.modal-section p {\r\n  color: #e2e8f0;\r\n}\r\n\r\n/* ======================================================\r\n   STATS\r\n====================================================== */\r\n\r\n.stat {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.stat-title {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 5px;\r\n  color: #cbd5e1;\r\n  font-size: 12px;\r\n}\r\n\r\n.stat-bar {\r\n  height: 8px;\r\n  overflow: hidden;\r\n  background: #1e293b;\r\n  border-radius: 10px;\r\n}\r\n\r\n.stat-bar div {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #f59e0b, #38bdf8);\r\n  border-radius: 10px;\r\n}\r\n\r\n/* ======================================================\r\n   TALENTS\r\n====================================================== */\r\n\r\n.ability-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.ability {\r\n  padding: 10px 12px;\r\n  color: #cbd5e1;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 8px;\r\n}\r\n\r\n.ability span {\r\n  float: right;\r\n  color: #f59e0b;\r\n  font-size: 9px;\r\n  font-weight: 800;\r\n}\r\n\r\n/* ======================================================\r\n   CAPACITES\r\n====================================================== */\r\n\r\n.moves {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  max-height: 160px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.moves span {\r\n  padding: 6px 9px;\r\n  color: #cbd5e1;\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 7px;\r\n  font-size: 10px;\r\n}\r\n\r\n/* ======================================================\r\n   EVOLUTION MODAL\r\n====================================================== */\r\n\r\n.modal-evolution {\r\n  overflow-x: auto;\r\n}\r\n\r\n/* ======================================================\r\n   DRESSEUR\r\n====================================================== */\r\n\r\n.trainer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  flex-wrap: wrap;\r\n  padding: 20px;\r\n  background: linear-gradient(135deg, #0f172a, #172033);\r\n  border: 1px solid #334155;\r\n  border-radius: 14px;\r\n}\r\n\r\n.trainer > img {\r\n  width: 90px;\r\n  height: 90px;\r\n  object-fit: contain;\r\n  image-rendering: pixelated;\r\n  border: 2px solid #38bdf8;\r\n  border-radius: 50%;\r\n  background: #1e293b;\r\n}\r\n\r\n.trainer > div:nth-child(2) {\r\n  flex: 1;\r\n}\r\n\r\n.trainer small {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  color: #64748b;\r\n  font-size: 9px;\r\n}\r\n\r\n.trainer h3 {\r\n  margin: 0 0 5px;\r\n    color: #f59e0b;\r\n\r\n}\r\n\r\n.trainer strong {\r\n  display: block;\r\n  margin-bottom: 10px;\r\n  color: #38bdf8;\r\n}\r\n\r\n.trainer p {\r\n  margin: 0;\r\n  color: #94a3b8;\r\n  font-size: 12px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* ======================================================\r\n   RESPONSIVE\r\n====================================================== */\r\n\r\n@media (max-width: 900px) {\r\n  .evolution-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .page-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .modal-hero {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .pokemon-page {\r\n    padding: 25px 10px;\r\n  }\r\n\r\n  .page-header h1 {\r\n    font-size: 1.8rem;\r\n  }\r\n\r\n  .statistics {\r\n    width: 100%;\r\n  }\r\n\r\n  .statistics div {\r\n    flex: 1;\r\n  }\r\n\r\n  .search-box input {\r\n    min-width: 100%;\r\n  }\r\n\r\n  .search-box select {\r\n    width: 100%;\r\n  }\r\n\r\n  .pagination {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .modal {\r\n    padding: 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
